import { ref } from 'vue';

/** Whether reference bodies should be transparent */
export const reference_transparent = ref(true);

let old_reference_transparent = true;

export function set_temporary_reference_transparency(transparent: boolean) {
    old_reference_transparent = reference_transparent.value;
    reference_transparent.value = transparent;
}

export function restore_reference_transparency() {
    reference_transparent.value = old_reference_transparent;
}
